import { combineReducers } from 'redux';

import {
  clearProductList,
  getProductListFail,
  getProductListRequest,
  getProductListSuccess,
  setProductListDirty,
} from '../actions';
import { ProductAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { ItemList } from '../../../../types/main';
import { Product } from '../../../../types/products';
import { stripItems } from '../../../../utility/store';

type State = Loadable<ItemList<Product>>;
type ReducerOf<T extends keyof State> = Reducer<State, ProductAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getProductListRequest.type:
      return state ? stripItems(state) : null;

    case getProductListSuccess.type:
      return action.payload;

    case clearProductList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getProductListRequest.type:
      return true;

    case getProductListSuccess.type:
    case getProductListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setProductListDirty.type:
      return action.payload;

    case getProductListSuccess.type:
    case getProductListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  dirty,
});
